<template>
  <div class="template">
    <template v-if="userSettingsStore.hasPermission(PermissionLevel.BASIC)">
      <slot></slot>
    </template>
    <template v-else>
      <FreemiumUpgradePopup :closable="false" title="Veille Transcriptions">
        <p>Ce contenu est réservé aux abonnements payants.</p>
        <p>
          En activant cette fonctionnalité, vous accédez à la retranscription de
          toutes les prises de parole à l’Assemblée nationale et au Sénat,
          directement reliées à vos sujets de veille. Plus besoin de visionner
          l’ensemble des séances : recevez des alertes en temps réel dès qu’un
          sujet ou un acteur vous concerne directement. Vous pouvez également
          figer la transcription à tout moment pour relire les échanges à votre
          rythme.
        </p>
      </FreemiumUpgradePopup>
    </template>
  </div>
</template>

<script setup>
import { PermissionLevel } from "@/follaw-fr/constants/enums/permission-level.enum";
import FreemiumUpgradePopup from "@follaw-fr/components/reusable/atoms/FreemiumUpgradePopup.vue";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";

const userSettingsStore = useUserSettingsStore();
</script>

<style scoped>
p {
  margin: 0;
}
</style>
